import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

export default function ProtectedRoute() {
  const location = useLocation();

  let user = null;

  try {
    user = JSON.parse(localStorage.getItem("user"));
  } catch {
    user = null;
  }

  // Not logged in → send to login
  if (!user) {
    return (
      <Navigate
        to="/Login"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  // Logged in → allow the requested page
  return <Outlet />;
}
